<template>
  <article class="record-item">
    <p class="date-line">{{ dateDisplay }}</p>
    <div class="row">
      <ProductThumb :size="90" alt="商品" />
      <div class="detail">
        <p class="qty">数量×{{ item.number }}</p>
        <p class="addr-label">收货地址信息</p>
        <div
          v-if="Number(item.status) > 1"
          class="addr-box"
          :class="{ 'is-placeholder': !String(item.address || '').trim() }"
        >
          {{ item.address || "暂无" }}
        </div>
        <div v-else class="addr-box">
          <textarea
            v-model.trim="shippingAddress"
            rows="4"
            placeholder="请输入收货信息（姓名、电话、完整地址），例如安徽省合肥市包河区某某小区，李先生，13055456733"
          />
        </div>
        <p v-if="Number(item.status) > 2 && item.waybill" class="tracking">
          运单号：{{ item.waybill }}
        </p>
        <button
          v-if="Number(item.status) === 1"
          type="button"
          class="btn btn-redeem"
          :disabled="submitting || !shippingAddress"
          @click="duihuanHandle"
        >
          {{ submitting ? "提交中…" : "确认收货地址" }}
        </button>
        <button v-else type="button" class="btn btn-shipped" disabled>
          {{
            Number(item.status) === 2
              ? "已确认"
              : Number(item.status) === 3
                ? "已发货"
                : "已收货"
          }}
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import ProductThumb from "@/components/ProductThumb.vue";
import { Notify, Toast } from "vant";
import { exchange_order } from "@/api";

export default {
  name: "PurchaseRecordItem",
  components: {
    ProductThumb,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      shippingAddress: "",
      submitting: false,
    };
  },
  computed: {
    dateDisplay() {
      const t = this.$utils.parseTime(this.item.created, "{y}.{m}.{d}");
      return t || "—";
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && Number(val.status) === 1) {
          this.shippingAddress = String(val.address || "").trim();
        }
      },
    },
  },
  methods: {
    async duihuanHandle() {
      if (Number(this.item.status) !== 1) {
        Notify({ type: "warning", message: "当前订单不可确认" });
        return;
      }
      const address = String(this.shippingAddress || "").trim();
      if (!address) {
        Notify({ type: "danger", message: "请填写收货信息" });
        return;
      }
      if (this.submitting) return;

      this.submitting = true;
      Toast.loading({ duration: 0, forbidClick: true });

      try {
        await exchange_order({
          id: String(this.item.id),
          address,
        });
        Notify({ type: "success", message: "操作成功" });
        this.$emit("exchange-success");
      } catch (_) {
        /* 错误文案由 axios 拦截器 Toast */
      } finally {
        Toast.clear();
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.record-item {
  margin-bottom: 48px;
}

.date-line {
  margin: 0 0 20px;
  font-size: 28px;
  font-weight: 600;
  color: #1a1a1a;
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.detail {
  flex: 1;
  min-width: 0;
}

.qty {
  margin: 0 0 12px;
  font-size: 26px;
  color: #1a1a1a;
}

.addr-label {
  margin: 0 0 8px;
  font-size: 24px;
  color: #333;
}

.addr-box {
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background: #fff;
  font-size: 24px;
  line-height: 1.45;
  color: #1a1a1a;
  word-break: break-word;

  textarea {
    display: block;
    border: none;
    outline: none;
    width: 100%;
    min-height: 140px;
    resize: vertical;
    font-size: 24px;
    line-height: 1.45;
    box-sizing: border-box;
  }
}

.addr-box.is-placeholder {
  color: #8c8c8c;
}

.tracking {
  margin: 16px 0 0;
  font-size: 24px;
  color: #333;
  line-height: 1.4;
}

.btn {
  width: 70%;
  margin-top: 24px;
  height: 60px;
  border: none;
  border-radius: 12px;
  font-size: 28px;
  font-weight: 500;
  box-sizing: border-box;
  cursor: pointer;
}

.btn-redeem {
  background: #e5c486;
  color: #fff;
  box-shadow: 0 2px 8px rgba(229, 196, 134, 0.35);
}

.btn-redeem:disabled {
  opacity: 0.55;
  cursor: default;
}

.btn-redeem:active:not(:disabled) {
  filter: brightness(0.97);
}

.btn-shipped {
  background: #dcdcdc;
  color: #666;
  cursor: default;
}
</style>
